import { render, staticRenderFns } from "./ClientEmailEdit.vue?vue&type=template&id=76f3b1da&"
import script from "./ClientEmailEdit.vue?vue&type=script&lang=js&"
export * from "./ClientEmailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports